import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import BaseService from '../../services/base.service';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
interface state {
  token: string | null;
  isLoading: boolean;
  error: string;
}

const initialState: state = {
  token: null,
  isLoading: false,
  error: '',
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<{ token: string }>) {
      const { token } = action.payload;
      state.token = token;

      BaseService.setApiBaseAndToken(process.env.REACT_APP_BASE_API as string, token);
    },
    logout(state) {
      state.token = null;
    },
    loginRequested(state, action: PayloadAction<{ walletAddress: string; chainId: number; signature: string }>) {
      state.isLoading = true;
    },
    loginSucceeded(state, action: PayloadAction<{ token: string }>) {
      const { token } = action.payload;
      toast.success('Connected with MetaMask');

      cookies.set('access_token', token, { expires: new Date(Date.now() + 24 * 60 * 60 * 1000), path: '/' });

      BaseService.setApiBaseAndToken(process.env.REACT_APP_BASE_API as string, token);

      state.token = token;
      state.isLoading = false;
    },
    loginFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;
      toast.error(message);

      state.error = message;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;
export const { setToken, logout, loginRequested, loginSucceeded, loginFailed } = slice.actions;
